const memoryStore = new Map<string, string>();

function tryGetLocalStorage(): Storage | null {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const probe = '__motisig_probe__';
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      return window.localStorage;
    }
  } catch {
    // SSR, privacy mode, or disabled storage -> fall back to memory.
  }
  return null;
}

export function hasPersistentStorage(): boolean {
  return tryGetLocalStorage() != null;
}

export function storageGetItem(key: string): string | null {
  const s = tryGetLocalStorage();
  if (s) return s.getItem(key);
  return memoryStore.get(key) ?? null;
}

export function storageSetItem(key: string, value: string): void {
  const s = tryGetLocalStorage();
  if (s) s.setItem(key, value);
  else memoryStore.set(key, value);
}

export function storageRemoveItem(key: string): void {
  const s = tryGetLocalStorage();
  if (s) s.removeItem(key);
  else memoryStore.delete(key);
}

export const STORAGE_KEYS = {
  anonymousId: 'motisig.anonymousId',
  anonymousIdProvider: 'motisig.anonymousIdProvider',
  userId: 'motisig.userId',
  pushSubscribed: 'motisig.pushSubscribed',
  pushToken: 'motisig.pushToken',
  swInstalledVersion: 'motisig.swVersion',
} as const;
